module.exports = __webpack_public_path__ + "img/université.b478678e.png";